import * as React from 'react';
import { isEmpty } from 'lodash';

import TileStandard from 'components/tiles/standard/TileStandard';

import './discovery-creators-results-tiles.scss';

import type { InfluencerTile as InfluencerTileType } from 'types';
import type { RecentPostsDataType } from 'modules/influencers/types/RecentPosts.type';

type Props = {
  creators: Array<InfluencerTileType>,
  influencerRecentPosts: {
    [x: number]: RecentPostsDataType
  },
  channel: string | undefined | null,
  expandedIdsMap: {
    [type: number]: string
  },
  isFreemium: boolean,
  globalTileSize: 'expanded' | 'collapsed',
  updateCreatorTileSize?: (size: string, creatorId: number) => void,
  onResetCreators: () => void,
  onFetchInfluencerPosts: (c: number, b: string, a: boolean) => void
};

class DiscoveryCreatorsResultsTiles extends React.PureComponent<Props> {
  componentWillUnmount() {
    const { onResetCreators } = this.props;

    onResetCreators();
  }

  renderTileWrapper = (creator: InfluencerTileType, index: number): JSX.Element => {
    const {
      channel,
      influencerRecentPosts,
      isFreemium,
      globalTileSize,
      expandedIdsMap,
      updateCreatorTileSize,
      onFetchInfluencerPosts
    } = this.props;

    return (
      <div
        key={`discovery-creators-results-tiles__tile--${creator.id}`}
        className="discovery-creators-results-tiles__tile"
      >
        <TileStandard
          key={`discovery-creators-results-tiles__tile-${creator.id}-${String(channel)}`}
          creator={creator}
          recentPosts={influencerRecentPosts[creator.id]?.posts || []}
          hasMorePostsToLoad={influencerRecentPosts[creator.id]?.hasMorePages ?? true}
          onFetchInfluencerPosts={onFetchInfluencerPosts}
          tileType="search"
          channel={channel}
          tileIndex={index}
          isFreemium={isFreemium}
          globalTileSize={expandedIdsMap[creator.id] || globalTileSize}
          updateCreatorTileSize={updateCreatorTileSize}
        />
      </div>
    );
  };

  render(): React.ReactNode {
    const { creators } = this.props;

    if (isEmpty(creators)) {
      return null;
    }

    return (
      <div className="discovery-creators-results-tiles">
        {
          creators.map(this.renderTileWrapper)
        }
      </div>
    );
  }
}

export default DiscoveryCreatorsResultsTiles;
